/* ==========================================================
!MainVisual
========================================================== */
(() => {
  /*window.onload = () => {};*/
  window.addEventListener('load', () => {
    const start = performance.now();
    const sceneTime = 4800;
    const linksTime = 6400;

    const lastScene = document.querySelectorAll('.js-mv-last-scene');
    const lastSceneArray = Array.prototype.slice.call(lastScene);

    if (lastSceneArray) {
      lastSceneArray.forEach((element) => {
        const scene = new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve();
          }, sceneTime);
        }).then(() => {
          const $this = element;
          $this.classList.add('is-active');
          //console.info($this);
        });

        const links = new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve();
          }, linksTime);
        }).then(() => {
          const $list = element.querySelector('.p-mv__list');
          const $detail = element.querySelector('.p-mv__detail');
          $list.classList.add('is-active');
          $detail.classList.add('is-active');
          //console.info($list, $detail);
        });
        /*const alwaysLateBoy = (ms) => {
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, ms);
          }).then(() => {
            console.log(`すまん！${ms}ms待たせたな。`);
          });
        };
        alwaysLateBoy(1500);*/
      });
    }
  });
})();
